(() => {
  const STYLE_ID = 'ggp-premium-sticky-style';
  const CSS = `
    @media(max-width:749px){
      .ggp-active-pdp.ggp-premium-sticky-active{padding-bottom:calc(9.2rem + env(safe-area-inset-bottom))!important}
      .ggp-active-pdp [data-ggp-sticky-pdp]:not([hidden]){
        position:fixed!important;
        z-index:46!important;
        left:0!important;right:0!important;bottom:0!important;
        display:grid!important;
        grid-template-columns:minmax(0,1fr) minmax(12.6rem,44%)!important;
        grid-template-rows:auto auto!important;
        align-items:center!important;
        gap:.28rem .8rem!important;
        width:100%!important;max-width:none!important;
        margin:0!important;
        padding:.72rem 1rem calc(.72rem + env(safe-area-inset-bottom))!important;
        box-sizing:border-box!important;
        border:0!important;border-top:1px solid rgba(31,78,69,.16)!important;
        border-radius:0!important;
        background:rgba(255,253,248,.97)!important;
        box-shadow:0 -8px 26px rgba(24,54,47,.13)!important;
        backdrop-filter:blur(12px)!important;-webkit-backdrop-filter:blur(12px)!important;
        font-family:Inter,'Noto Sans Bengali',sans-serif!important;
      }
      .ggp-active-pdp [data-ggp-sticky-pdp] .ggp-sticky-pdp__meta{
        grid-column:1!important;grid-row:2!important;
        display:flex!important;flex-direction:column!important;align-items:flex-start!important;justify-content:center!important;gap:.15rem!important;min-width:0!important;
        margin:0!important;padding:0!important;
      }
      .ggp-active-pdp [data-ggp-sticky-pdp].ggp-sticky-pdp--single .ggp-sticky-pdp__meta{
        grid-row:1 / span 2!important;align-self:center!important;
      }
      .ggp-active-pdp [data-ggp-sticky-pdp] .ggp-sticky-pdp__name{display:block!important;color:#68766e!important;font-size:1.08rem!important;font-weight:500!important;line-height:1.25!important}
      .ggp-active-pdp [data-ggp-sticky-pdp] .ggp-sticky-pdp__price{
        color:#1f4e45!important;font-size:1.35rem!important;line-height:1.2!important;font-weight:750!important;white-space:nowrap!important;
      }
      .ggp-active-pdp [data-ggp-sticky-pdp] .ggp-sticky-pdp__actions{display:contents!important}
      .ggp-active-pdp [data-ggp-sticky-pdp] .ggp-sticky-pdp__select-wrap{
        grid-column:1!important;grid-row:1!important;display:block!important;min-width:0!important;margin:0!important;padding:0!important;
      }
      .ggp-active-pdp [data-ggp-sticky-pdp] .ggp-sticky-pdp__select-wrap select{
        display:block!important;width:100%!important;min-width:0!important;height:3.2rem!important;margin:0!important;
        padding:.18rem 2.2rem .18rem .72rem!important;
        border:1px solid #abc0b6!important;border-radius:.8rem!important;
        background-color:#fffdf8!important;color:#1f4e45!important;
        font-size:1.18rem!important;line-height:1.2!important;font-weight:650!important;
        text-overflow:ellipsis!important;white-space:nowrap!important;
        box-shadow:none!important;
      }
      .ggp-active-pdp [data-ggp-sticky-pdp] .ggp-sticky-pdp__button{
        grid-column:2!important;grid-row:1 / span 2!important;
        width:100%!important;min-width:0!important;height:5.15rem!important;min-height:5.15rem!important;
        margin:0!important;padding:0 .65rem!important;border:0!important;border-radius:1rem!important;
        background:#a1552f!important;color:#fff!important;
        font-family:Inter,'Noto Sans Bengali',sans-serif!important;font-size:1.34rem!important;line-height:1.25!important;font-weight:750!important;
        box-shadow:0 4px 13px rgba(128,72,43,.20)!important;cursor:pointer!important;
      }
      .ggp-active-pdp [data-ggp-sticky-pdp] .ggp-sticky-pdp__button:disabled{opacity:.55!important;cursor:not-allowed!important}
      @media(max-width:360px){
        .ggp-active-pdp [data-ggp-sticky-pdp]:not([hidden]){
          grid-template-columns:minmax(0,1fr) minmax(11.7rem,43%)!important;
          padding-left:.7rem!important;padding-right:.7rem!important;gap:.2rem .55rem!important;
        }
        .ggp-active-pdp [data-ggp-sticky-pdp] .ggp-sticky-pdp__button{font-size:1.22rem!important}
        .ggp-active-pdp [data-ggp-sticky-pdp] .ggp-sticky-pdp__select-wrap select{font-size:1.1rem!important}
      }
    }
  `;

  const injectStyle = () => {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = CSS;
    document.head.appendChild(style);
  };

  const textOf = (el) => ((el?.innerText || el?.textContent || el?.value || '') + '').replace(/\s+/g, ' ').trim();
  const BN_DIGITS = '০১২৩৪৫৬৭৮৯';
  const toBnDigits = (value) => String(value).replace(/\d/g, (digit) => BN_DIGITS[Number(digit)]);

  const localizeReviewCount = (scope = document) => {
    scope.querySelectorAll?.('.jdgm-prev-badge__text').forEach((el) => {
      const current = textOf(el);
      const match = current.match(/^(\d+)\s+reviews?$/i);
      if (!match) return;
      const localized = `${toBnDigits(match[1])}টি রিভিউ`;
      if (current !== localized) el.textContent = localized;
    });
  };

  const localizePdpPrices = (scope = document) => {
    scope.querySelectorAll?.('.price--large .price-item').forEach((el) => {
      const current = textOf(el);
      if (!/\bTk\.?\s*/i.test(current)) return;
      const localized = current
        .replace(/\bTk\.?\s*/gi, '৳')
        .replace(/\s*BDT\b/gi, '')
        .replace(/৳\s+/g, '৳');
      if (current !== localized) el.textContent = localized;
    });
  };

  const localizePdpUi = (scope = document) => {
    localizeReviewCount(scope);
    localizePdpPrices(scope);
  };

  const setup = (root = document) => {
    injectStyle();
    root.querySelectorAll('[data-ggp-sticky-pdp]:not([data-ggp-ready])').forEach((bar) => {
      bar.dataset.ggpReady = 'true';
      const section = bar.closest('product-info');
      if (!section) return;
      const info = section.querySelector('.product__info-container') || section;
      const button = bar.querySelector('[data-ggp-sticky-add]');
      const option = bar.querySelector('[data-ggp-sticky-option]');
      const price = bar.querySelector('[data-ggp-sticky-price]');
      if (!button || !price) return;
      if (!option) bar.classList.add('ggp-sticky-pdp--single');

      let pendingOption = '';
      let scrollFrame = 0;

      const selectedVariant = () => {
        try {
          const json = info.querySelector('variant-selects [data-selected-variant]')?.textContent;
          if (json) return JSON.parse(json);
        } catch {}
        return null;
      };

      const formatMoney = (cents) => '৳' + new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format((Number(cents) || 0) / 100);
      const nativeButton = () => info.querySelector('product-form .product-form__submit[name="add"]');
      const mobile = () => window.matchMedia('(max-width: 749px)').matches;
      const updateVisibility = () => {
        const native = nativeButton();
        const cartDrawer = document.querySelector('cart-drawer');
        const rect = native?.getBoundingClientRect();
        const show = Boolean(
          mobile() && rect && rect.width > 0 && rect.height > 0 &&
          rect.bottom <= 0 &&
          native && !native.disabled &&
          native.getAttribute('aria-disabled') !== 'true' &&
          !cartDrawer?.classList.contains('active') &&
          !document.body.classList.contains('overflow-hidden') &&
          !pendingOption
        );
        if (bar.hidden === show) {
          bar.hidden = !show;
          document.body.classList.toggle('ggp-premium-sticky-active', show);
        }
      };
      const scheduleVisibility = () => {
        if (scrollFrame) return;
        scrollFrame = window.requestAnimationFrame(() => {
          scrollFrame = 0;
          updateVisibility();
        });
      };

      const sync = () => {
        if (!bar.isConnected) return;
        localizePdpUi(section);
        const selected = selectedVariant();
        if (option && selected?.option1) {
          if (pendingOption && selected.option1 === pendingOption) pendingOption = '';
          if (!pendingOption && option.value !== selected.option1) option.value = selected.option1;
        }
        if (selected?.price != null) {
          const amount = formatMoney(selected.price);
          if (price.textContent !== amount) price.textContent = amount;
        }
        const unavailable = selected?.available === false;
        const native = nativeButton();
        const disabled = Boolean(pendingOption || unavailable || !native || native.disabled || native.getAttribute('aria-disabled') === 'true');
        if (button.disabled !== disabled) button.disabled = disabled;
        const cta = unavailable ? 'স্টকে নেই' : 'কার্টে যোগ করুন';
        if (button.textContent !== cta) button.textContent = cta;
        const label = bar.querySelector('.ggp-sticky-pdp__name');
        if (label && label.textContent !== 'নির্বাচিত পণ্য') label.textContent = 'নির্বাচিত পণ্য';
        scheduleVisibility();
      };

      option?.addEventListener('change', () => {
        const value = option.value;
        const radios = [...info.querySelectorAll('variant-selects input[type="radio"]')];
        const input = radios.find((item) => item.value === value);
        const select = [...info.querySelectorAll('variant-selects select')].find((item) => [...item.options].some((opt) => opt.value === value));
        const control = input || select;
        if (!control) {
          info.querySelector('variant-selects')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        pendingOption = value;
        button.disabled = true;
        if (input) input.checked = true;
        else select.value = value;
        control.dispatchEvent(new Event('change', { bubbles: true }));
        window.setTimeout(sync, 180);
      });

      button.addEventListener('click', () => {
        if (button.disabled || pendingOption) return;
        const native = nativeButton();
        if (!native || native.disabled || native.getAttribute('aria-disabled') === 'true') return;
        button.disabled = true;
        native.click();
        scheduleVisibility();
      });

      info.addEventListener('change', (event) => {
        if (event.target.closest('variant-selects')) window.setTimeout(sync, 0);
      });

      const observer = new MutationObserver(() => {
        if (!bar.isConnected) {
          observer.disconnect();
          window.cancelAnimationFrame(scrollFrame);
          return;
        }
        sync();
      });
      observer.observe(info, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'checked', 'value'] });

      window.addEventListener('scroll', scheduleVisibility, { passive: true });
      window.addEventListener('resize', scheduleVisibility, { passive: true });
      document.addEventListener('click', () => window.setTimeout(scheduleVisibility, 80), { passive: true });

      sync();
      updateVisibility();
      window.setTimeout(() => localizePdpUi(section), 250);
      window.setTimeout(() => localizePdpUi(section), 900);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup(), { once: true });
  else setup();
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
})();